import $ from 'jquery';

$(document).ready(function(){

  
    // Header Slider
    $('.header-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        draggable: true,
        arrows: false,
        dots: true,
        fade: true,
        speed: 900,
        infinite: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        touchThreshold: 100
    });


    // Partners Slider
    var $slickLogoslider = jQuery('.logoslider');

    function setSlickLogoslider(){

        $slickLogoslider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,
        variableWidth: true,/* ian test */
        responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
        }
        },
        {
            breakpoint: 600,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
        },
        ]
        });
    }

    // Partners Scrolling
    setSlickLogoslider();  
    $('.scrolling').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
    });

    // Post Carousel
    $('.post-carousel').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      appendArrows: $('.post__arrows'),
        prevArrow: '<div class="post__arrow post__arrow_dir_left"><i class="fas fa-chevron-left"></i></div>',
        nextArrow: '<div class="post__arrow post__arrow_dir_right"><i class="fas fa-chevron-right"></i></div>',
		 dots: true,
		 appendDots: $('.post__dots'),
		     customPaging : function(slider, i) {
      var thumb = $(slider.$slides[i]).data();

      return (i + 1);
            },
		  dotsClass: 'post__dots-list',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    // Post Scroll
    $('.post-scrolling').slick({
      dots: true,
      infinite: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 3,
      appendArrows: $('.post__arrows'),
        prevArrow: '<div class="post__arrow post__arrow_dir_left"><i class="fas fa-chevron-left"></i></div>',
        nextArrow: '<div class="post__arrow post__arrow_dir_right"><i class="fas fa-chevron-right"></i></div>',
		 dots: true,
		 appendDots: $('.post__dots'),
		     customPaging : function(slider, i) {
      var thumb = $(slider.$slides[i]).data();

      return (i + 1);
            },
		  dotsClass: 'post__dots-list',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    $('.team-slider').slick({
      dots: true,
      infinite: true,
      arrows: true,
      speed: 1000,
      slidesToShow: 4,
      slidesToScroll: 4,    
      autoplay: true,
      autoplaySpeed: 8000,    
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                centerMode: true,
                centerPadding: '60px'
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]     
    });

     $('.portfolio-slider').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 1000,
      slidesToShow: 4,
      slidesToScroll: 4,    
      autoplay: true,
      autoplaySpeed: 8000,    
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
                arrows: false,
                centerMode: true,
                centerPadding: '60px'
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]     
    });

    $('.post-slider').slick({
      dots: true,
      infinite: true,
      arrows: true,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 3,    
      autoplay: true,
      autoplaySpeed: 8000,    
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                centerMode: true,
                centerPadding: '30px'
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]     
    });

    $(".prev-btn.custom").click(function () {
      $(".custom-slider").slick("slickPrev");
    });
    
    $(".next-btn.custom").click(function () {
      $(".custom-slider").slick("slickNext");
    });
    $(".prev-btn.custom").addClass("slick-disabled");
    $(".custom-slider").on("afterChange", function () {
      if ($(".slick-prev.custom").hasClass("slick-disabled")) {
        $(".prev-btn.custom").addClass("slick-disabled");
      } else {
        $(".prev-btn.custom").removeClass("slick-disabled");
      }
      if ($(".slick-next.custom").hasClass("slick-disabled")) {
        $(".next-btn.custom").addClass("slick-disabled");
      } else {
        $(".next-btn.custom.custom").removeClass("slick-disabled");
      }
    });



});